import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { userGroupUnsubscribe } from '../../api/actions/user-groups/user-group-unsubscribe';
import { Loader } from '../../components/loader/loader';
import { MainLayout } from '../../components/layouts/main-layout';
import { MultiError } from '../../types/multi-error';
import { PublicPage } from '../base/public-page';
import styles from './unsubscribe-page.module.scss';

export function UnsubscribePage() {
    const [code] = useState(
        new URL(window.location.href).searchParams.get('code') || undefined
    );

    const [loading, setLoading] = useState<string | undefined>(
        'Please wait, unsubscribing...'
    );
    const [error, setError] = useState<string | undefined>();
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        unsubscribe();
    }, []);

    const unsubscribe = async () => {
        if (!code) {
            setLoading(undefined);
            setError('Invalid group');
            return;
        }

        try {
            const result = await userGroupUnsubscribe(code);

            if (result.success) {
                setSuccess(true);
                toast.success('You have been unsubscribed successfully.');
            } else {
                setError('Unable to unsubscribe from this group.');
                toast.error('ERROR: Unable to unsubscribe from this group.');
            }
        } catch (err) {
            const message = (err as MultiError).message || 'Unknown error';
            setError(message);
            toast.error(`ERROR: ${message}`);
        }

        setLoading(undefined);
    };

    return loading ? (
        <Loader text={loading} />
    ) : (
        <PublicPage pageName="unsubscribe_page">
            <MainLayout>
                <div className={styles.container}>
                    <div className={styles.messageContainer}>
                        {success && (
                            <span className={styles.message}>
                                You have been unsubscribed successfully.
                            </span>
                        )}
                        {error && (
                            <div className="errors">
                                <span className={styles.message}>{error}</span>
                            </div>
                        )}
                    </div>
                </div>
            </MainLayout>
        </PublicPage>
    );
}
